import React ,{useState ,useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import warningIcon from 'images/warning.png';

import CenterModal from 'components/presenters/modal/CenterModal';

import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'
import AnimationModal from 'components/presenters/common/AnimationModal';
import LottieLoader from 'components/containers/common/LottieLoader';

import server from 'server/serverController2';
import { isValidEmail } from 'utils/utils';
import { EmailResetForm, FieldList, FormTitle, EmailField, ErrorMessage, WarningImg, BtnWrapper, RequestBtn, ValidRequestBtn } from './style';
export default function PasswordResetRequestForm() {
	const history = useHistory();

	const [isRequesting, setIsRequesting] = useState(false);
	const [isValid, setIsValid] = useState(false);
	const [errMsg, setErrMsg] = useState(null);
    const [email,setEmail] = useState("");

	//Center Modal State
	const [initCenterModal, setInitCenterModal] = useState(false);
	const [centerModalVisible, setCenterModalVisible] = useState(false);
	const [centerModalDataList, setCenterModalDataList] = useState({});
	const [onModalComplete, setOnModalComplete] = useState(null);
	const [onModalCancel, setOnModalCancel] = useState(null);

	//Init Center Modal State
	useEffect(()=>{
		if(initCenterModal === true)
		{
			setCenterModalVisible(false);
			setCenterModalDataList({})
			setOnModalComplete(null);
			setOnModalCancel(null);
			setInitCenterModal(false);
		}
	}, [initCenterModal])

    const handleEmailChange = (e) =>{ 
    	let emailTxt = e.target.value;
    	const validationResult = isValidEmail(emailTxt);
    	setEmail(emailTxt); 
    	setIsValid(validationResult);
    	if(validationResult === true)
    	{
    		setErrMsg(null);
    	}
    }
    const handleFocusOut = (e) =>{
    	const validationResult = isValidEmail(email);
    	setIsValid(validationResult);
    	if(validationResult === false)
    	{
    		setErrMsg("이메일 형식이 올바르지 않습니다.");
    	}
    	else
    	{
    		setErrMsg(null);
    	}
    }

    const requestResetEmail = (e) => {
    	if(isRequesting === false)
    	{
    		setIsRequesting(true)

			const form = {
				email:email
			};
			server.postRequestData(`auth/password/reset`,form, (res)=>{
				if(res['success'] === 0)
				{
					let errData = res['error']['res_data'];

					setIsRequesting(false);
					setCenterModalVisible(true);
					if(errData['detail_code']==='NOT_ACTIVATED_ACCOUNT')
					{
						setCenterModalDataList({description:"활성화된 계정이 아닙니다."});
						setOnModalComplete(()=>()=>{
							setInitCenterModal(true);
						})
					}
					else if(errData['detail_code']==='USER_EMAIL_NOT_EXIST')
					{
						setCenterModalDataList({description:"해당 이메일은 가입된 이메일이 아닙니다."});
						setOnModalComplete(()=>()=>{
							setInitCenterModal(true);
						})
					}
					else
					{
						setCenterModalDataList({description:"이메일 초기화에 실패했습니다. 관리자 admin@unitmi.com 으로 문의해주세요."});
						setOnModalComplete(()=>()=>{
							setInitCenterModal(true);
						})
					}
					return ;
				}
				setIsRequesting(false);
				setCenterModalVisible(true);
				setCenterModalDataList({description:`${email}로 비밀번호 초기화 링크를 보냈어요.`});
				setOnModalComplete(()=>()=>{
					setInitCenterModal(true);
					history.replace('/social');
				})
			});
    	}
    }

	const lottieOptions = {
		loop: true,
		autoplay: true,
		renderer: 'svg',
		animationData: loadingAnimation
	}
	return (
		<EmailResetForm> 
			<FieldList>
				<FormTitle>이메일 주소</FormTitle>
				<EmailField type="email" placeholder="이메일주소를 입력해 주세요" value={email} onChange={handleEmailChange} onBlur={handleFocusOut}/>
				{
					(errMsg)
					?(<ErrorMessage><WarningImg src={warningIcon} />{errMsg}</ErrorMessage>)
					:(<ErrorMessage> </ErrorMessage>)
				}
			</FieldList> 
			{
				(isValid)
				?(
					<BtnWrapper onClick={requestResetEmail}>
						<ValidRequestBtn>비밀번호 변경요청</ValidRequestBtn>
					</BtnWrapper>
				)
				:(
					<BtnWrapper>
						<RequestBtn>비밀번호 변경요청</RequestBtn>
					</BtnWrapper>
				)
			}
			<CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
			{
				(isRequesting)
				?(
					<AnimationModal>
					<LottieLoader lottieOptions={lottieOptions} style={{width: 'calc(100vw * (200 / 375))'}} />
					</AnimationModal>
				)
				:(null)
			}
			  
		</EmailResetForm>
	)
}
